import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FeedProfile } from '@vestiaire/api-sdk-angular';
import { environment } from '@env/environment';
import { FeedCardsService } from '@app/+feed/service/feed-cards.service';

export interface ISeeMemberEvent {
  emitter: 'button' | 'link';
  profileId?: string;
  trackingKey?: string;
}

@Component({
  selector: 'vc-feed-card-profile',
  templateUrl: './feed-card-profile.component.html',
  styleUrls: ['./feed-card-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedCardProfileComponent {
  @Input() profile: FeedProfile;
  @Input() cardType: string;
  imagesPath = environment.imgixPath;
  feedType = 'default';
  justBeenFollowed = false;

  @Output() followMemberFeed = new EventEmitter<FeedProfile>();
  @Output() seeMember = new EventEmitter<ISeeMemberEvent>();

  constructor(private feedService: FeedCardsService) {
    this.feedType = this.feedService.feedType;
  }

  toFollow() {
    this.justBeenFollowed = true;
    this.profile.isFollowed = true;
    this.followMemberFeed.emit(this.profile);
  }
}
